import { render, staticRenderFns } from "./AamsDocumentRegReceiveInfo.vue?vue&type=template&id=7750f3eb&scoped=true&"
import script from "./AamsDocumentRegReceiveInfo.vue?vue&type=script&lang=js&"
export * from "./AamsDocumentRegReceiveInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7750f3eb",
  null
  
)

export default component.exports